// components/PrintPage.js
import React from 'react';
import { PdfButton } from './pdfRenderer.js';

function PrintPage({ type, response, queryLine, messages, transactionID, driverPhotoBase64, fileName }) {
  return (
    <div >
      <PdfButton
        type={type}
        response={response}
        queryLine={queryLine}
        messages={messages}
        transactionID={transactionID}
        driverPhotoBase64={driverPhotoBase64}
        fileName={fileName}
      />
    </div>
  );
}

export default PrintPage;
